export const loadCK = () => {
  return (dispatch: any) =>
    dispatch({
      type: 'preLoadCheckout'
    });
};

export const preLoadCheckout = () => {
  return (dispatch: any) => {
    dispatch(loadCK());
  };
};
